import React, { useState, useEffect } from "react";
import Request from "../../helpers/Request";
import dpd_logo from "images/couriers/dpd_logo.png";
import omniva_logo from "images/couriers/omniva_logo.png";
import tnt_logo from "images/couriers/tnt_logo.png";
import ups_logo from "images/couriers/ups_logo_new.png";
import lp_logo from "images/couriers/lp_logo.png";
import gls_logo from "images/couriers/gls_logo.png";
import roayl_mail_logo from "images/couriers/royal_mail.png";
import venipak_logo from "images/couriers/venipak-logo.png";
import fedex_logo from "images/couriers/fedex_logo.png";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";
import { Carousel } from 'react-responsive-carousel';

const HeroCarousel = () => {
  const [images, setImages] = useState([]);

  const settings = {
    dots: false,
    infinite: true,
    centerMode: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    variableWidth: true,
    autoplay: true,
    speed: 4000,
    autoplaySpeed: 3000,
    cssEase: "linear"
  };

  useEffect(() => {
    Request("/hero_carousel_images", "GET")
      .then((response) => {
        if (response.images) setImages(response.images)
      })
      .catch(({ errors }) => {
        console.log("errors from catch: ", errors)
      })
  }, [])

  const images2 = [
    dpd_logo,
    omniva_logo,
    lp_logo,
    gls_logo,
    roayl_mail_logo,
    ups_logo,
    venipak_logo,
    fedex_logo
  ]


  const carouselOptions = {
    showIndicators: false,
    showThumbs: false,
    showStatus: false,
    infiniteLoop: true,
    autoPlay: true,
    inverval: 8000
  };


  return (
    <>
      {images.length > 0 && (
        <div className="hero-carousel">
          <Carousel {...carouselOptions}>
            {images.map((image, index) => (
              <div key={index} onClick={() => window.open(image.url)}>
                <img src={image.asset.url} alt={image.alt} />
              </div>
            ))}
          </Carousel>
        </div>
      )}
      {images2.length > 0 && (
        <div className="hero-carousel2">
          <Slider {...settings}>
            {images2.map((image, index) => (
              <div key={index} style={{ paddingLeft: "10px", paddingRight: "10px" }}>
                <img src={image} alt={`Carousel image ${index + 1}`} style={{ width: "auto", maxHeight: "45px", marginLeft: "10px", marginRight: "10px" }} />
              </div>
            ))}
          </Slider>
        </div>
      )}
    </>
  );
}

export default HeroCarousel;
